import React, { Component } from "react";
import { websiteUrl } from '../../utils/common';

const CViewLive = () => 
{ 
  var WEB_URL=websiteUrl();
  const urlSearchString = window.location.search;
  const params = new URLSearchParams(urlSearchString);
  const IEMINo = params.get('ID');
  
  const strUrl=WEB_URL+`Live.html?ID=` + IEMINo;
  //const strUrl="http://localhost:3000/Live.html?ID=" + IEMINo;
 
     return (               
          <iframe width="1800px" height="900px" src={strUrl}  title="" ></iframe>         
       )}; 
   
export default CViewLive;